import { Accordion } from "@au-schein-de/au-ui-library";
import type { ProductNoEdibleInfo } from "@dransay/api";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import { getProductDescription } from "~/utils/get-product-description";
import { ProductDetailsCTAInfoBox } from "./product-details-cta-info-box.component";

type ProductDetailsDescriptionAccordionProps = {
	product: ProductNoEdibleInfo;
	showAttributes?: boolean;
};

export function ProductDetailsDescriptionAccordion({
	product,
	showAttributes = true,
}: ProductDetailsDescriptionAccordionProps) {
	const { t } = useTranslation();
	const description = getProductDescription(product, t);

	return (
		<>
			<Accordion.Trigger>
				<h2 className="flex items-center">
					<span className="text-body-bold text-gray-700">
						{t("description")}
					</span>
				</h2>
			</Accordion.Trigger>
			<Accordion.Content className="pt-6">
				<div className="flex flex-col gap-6">
					{showAttributes && <ProductDetailsCTAInfoBox product={product} />}
					{description && (
						<div className="text-body-sm text-gray-700 flex flex-col gap-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1 [&_strong]:text-body-sm-emphasis">
							{/* Description which comes from the third-party could be HTML. rehype-raw parses the
							    embedded markup into nodes, then rehype-sanitize strips
							    anything unsafe (scripts, event handlers, javascript: URLs). */}
							<Markdown
								remarkPlugins={[remarkGfm]}
								rehypePlugins={[rehypeRaw, rehypeSanitize]}
							>
								{description}
							</Markdown>
						</div>
					)}
				</div>
			</Accordion.Content>
		</>
	);
}
